export const ROOM_ROUTE_NAME = 'room'
export const ROOM_SETTINGS_ROUTE_NAME = 'room.settings'
export const ROOM_CUSTOMIZATION_ROUTE_NAME = 'room.customization'

export const ROOM_ROUTES_NAMES = new Set([
  ROOM_ROUTE_NAME,
  ROOM_SETTINGS_ROUTE_NAME,
  ROOM_CUSTOMIZATION_ROUTE_NAME,
])
